import { Button, Row } from 'antd';
import styled from 'styled-components';
import { StyledSteps } from 'components/new-ui/composed/multistep-form/styles';

export const Steps = styled(StyledSteps)`
    &.ant-steps-navigation {
        border-bottom: 1px solid var(--gray-4);

        .ant-steps-item-active .ant-steps-item-title {
            color: var(--brand-6);
            font-weight: 600;
        }
    }
`;

export const CustomerAddressRow = styled(Row)`
    @media (min-width: 1025px) and (max-width: 1599px) {
        flex-direction: column;

        > .ant-col {
            width: 100% !important;
            max-width: 100% !important;
            flex: 0 0 100% !important;
            padding: 0 !important;
        }

        > .ant-col + .ant-col {
            margin-top: 16px;
        }
    }
`;

export const CustomerContactContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const CustomerContactHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
`;

export const CustomerContactHeaderText = styled.h2`
    margin: 0;
`;

export const CustomerContactHeaderButton = styled(Button)`
    margin: 0;
    font-weight: 600;
`;

export const OptionTitle = styled.div`
    font-weight: 600;
`;

export const DutyPayerOptionRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    color: var(--gray-8);
    font-weight: 400;
`;

export const OptionRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
`;

export const TruncatedOptionLabel = styled.span`
    flex: 0 1 auto;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const SectionContainer = styled.div`
    padding: 12px;
    border-radius: 6px;
    border: 1px solid var(--brand-2);
    background: hsla(255, 44%, 93%, 0.5);
    background: color-mix(in srgb, var(--brand-1) 50%, transparent);
`;
